import {Component, Input, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {RemedyPersonSelectComponent} from "../remedy/remedy-person-select.component";

@Component({
  selector: 'micro-incident-detail',
  templateUrl: './incident-detail.component.html'
})
export class IncidentDetailComponent extends BaseComponent implements OnChanges {
  @Input() incident:any;
  @Input() connectionId:any;
  @Input() id:any;

  @ViewChild(RemedyPersonSelectComponent) customerPersonSelect: RemedyPersonSelectComponent;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    if (!this.incident) {
      this.route.params
        .subscribe((params: Params) => {
          this.id = params['id'];
          this.connectionId = params['connectionId'];
          if (this.id === 'new') {
            this.createNewIncident();
          } else {
            this.reload();
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'connectionId') {
        this.reload();
      }
    }
  }

  reload() {
    if (this.connectionId && this.id !== 'new') {
      this.http.get(`${this.env.e.url}/remedy/incidents/${this.id}?connection=${this.connectionId}`).subscribe(
        data => {
          this.incident = data as any;
        }
      );
    }
  }

  createNewIncident() {
    this.incident = {
      personId: ''
    };
  }

  save() {
    if (!this.connectionId) {
      this.alertService.warn('Please select a valid remedy connection');
      return;
    }

    let person = this.customerPersonSelect.getSelectedPerson();
    if (!person) {
      this.alertService.warn('Please select a customer contact');
      return;
    }
    this.incident.customerFirstName = person.firstName;
    this.incident.customerLastName = person.lastName;

    if (!this.incident.requestId) {
      this.http.post(`${this.env.e.url}/remedy/incidents?connection=${this.connectionId}`, this.incident)
        .subscribe(
          data => {
            this.incident = data;
            this.alertService.info(`Created ${this.incident.requestId}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/remedy/incidents/${this.incident.requestId}?connection=${this.connectionId}`, this.incident)
        .subscribe(
          data => {
            this.incident = data;
            this.alertService.info(`Updated ${this.incident.requestId}`);
          }
        );
    }
  }
}
